// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 11 14", width: "11", height: "14" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M26.5006111,642 C22.8333333,642 21,644.625 21,647.25 C21,649.875 26.5006111,656 26.5006111,656 C26.5006111,656 32,649.875 32,647.25 C32,644.625 30.1666667,642 26.5006111,642 Z M26.5,649.5 C25.3953333,649.5 24.5,648.604667 24.5,647.5 C24.5,646.395333 25.3953333,645.5 26.5,645.5 C27.6046667,645.5 28.5,646.395333 28.5,647.5 C28.5,648.604667 27.6046667,649.5 26.5,649.5 Z", transform: "translate(-21 -642)" })))));
};
Icon.displayName = 'Location11x14';
export default Icon;
//# sourceMappingURL=Location11x14.js.map